"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var formik_1 = require("formik");
var asg_1 = require("@alinta-digital/asg");
var Styles_1 = require("./Styles");
var PaymentDetails_1 = require("../../view/PaymentDetails");
var PaymentAmount = function (props) {
    var disabled = props.disabled;
    var setFieldValue = formik_1.useFormikContext().setFieldValue;
    return (react_1.default.createElement(Styles_1.StyledBox, { margin: { top: 'medium' }, width: "100%", maxWidth: "704px" },
        react_1.default.createElement(formik_1.Field, { name: PaymentDetails_1.SECTION_KEY + ".paymentAmount", id: PaymentDetails_1.SECTION_KEY + ".paymentAmount", "data-testid": PaymentDetails_1.SECTION_KEY + "-paymentAmount", ariaRequired: true, type: "tel", label: "Payment amount", placeholder: "Payment amount", component: asg_1.FormMaskedTextInput, options: {
                prefix: '$',
                numeral: true,
                stripLeadingZeroes: false,
                numeralThousandsGroupStyle: 'none',
                numeralDecimalMark: '.',
                numeralPositiveOnly: true
            }, disabled: disabled, onBlur: function (_a) {
                var target = _a.target;
                var valueWithoutPrefix = target.value.slice(1);
                if (valueWithoutPrefix.length === 0)
                    return;
                var splitValue = valueWithoutPrefix.split('.');
                var leftValue = splitValue[0];
                var rightValue = splitValue[1];
                var transformedLeftValue = typeof leftValue !== 'undefined' && leftValue.length ? leftValue : '0';
                var transformedRightValue = typeof rightValue !== 'undefined' && rightValue.length ? rightValue : '00';
                if (transformedRightValue.length === 1)
                    transformedRightValue = transformedRightValue + '0';
                setFieldValue(PaymentDetails_1.SECTION_KEY + ".paymentAmount", transformedLeftValue + "." + transformedRightValue);
            } })));
};
exports.default = PaymentAmount;
//# sourceMappingURL=PaymentAmount.js.map